import { createSlice } from '@reduxjs/toolkit';

const slice = createSlice({
    name: 'pagePermissionsSlice',
    initialState: {
        permissions: []
    },
    reducers: {
        pagePermissionsSlice: (state, action) => {
            return {
                ...state,
                permissions: action.payload?.permissions
            };
        }
    }
});

export const { pagePermissionsSlice } = slice.actions;
export default slice.reducer;
